import { Badge, Form, Spinner } from "@themesberg/react-bootstrap";
import React, { useState } from "react";
import { APIURL } from "../../../../configApi";
import axios from "axios";
import { config } from "../../../../authentication/auth";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { axiosInstance } from "../../../../config/axios";

export default function (props) {
  const { checked, id } = props;
  const [localCheck, setLocalCheck] = useState(checked);
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const ChangeCalculationStatus = () => {
    setLoading(true);
    axiosInstance
      .put(`${APIURL}/laboratory/payments/${id}/change_to_to_calculated`, {
        is_to_be_calculated: !checked,
      })
      .then((res) => {
        setLocalCheck((prevState) => !prevState);
        if (!localCheck)
          NotificationManager.success(
            "Le paiement va être calculé",
            "Notification"
          );
        else
          NotificationManager.error(
            "Le paiement va être reporté",
            "Notification"
          );
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      }); // console.log(err)); //
  };

  return (
    <>
      {loading ? (
        <Spinner animation="border"  />
      ) : (
        <Form.Check
          type="switch"
          id="custom-switch"
          checked={localCheck}
          onChange={ChangeCalculationStatus}
        />
      )}
    </>
  );
}
